import { css } from 'styled-components';

export const baseFontCss = css`
  font-family: ${({ theme }) => theme.text.font};
  letter-spacing: ${({ theme }) => theme.text.letterSpacing};
`;

export const defaultTextCss = css`
  ${baseFontCss};
  color: ${({ theme }) => theme.colours.default.text};
`;

export const defaultNormalTextCss = css`
  ${baseFontCss};
  font-size: ${({ theme }) => theme.text.sizeLarge};
  line-height: ${({ theme }) => theme.text.lineHeight};
`;

export const defaultBoldTextCss = css`
  ${defaultNormalTextCss};
  font-weight: bold;
`;

export const inputFocused = css`
  background-color: ${({ theme }) => theme.colours.input.focus.background};
  border-color: ${({ theme }) => theme.colours.input.focus.border};
`;
